import { createContext, FC, PropsWithChildren } from 'react';
import { Business, FirmClient, InsurancePolicy, Loan, RealEstate, Scorecard } from '../../../../generated/graphql';
import { IFeatureFlagsContext } from '../../../../FeatureFlags';
import { InsuranceRateClickHandlers } from '../../../context';

export interface IInsuranceElementDetailViewContext
  extends Pick<IFeatureFlagsContext, 'allowBAA' | 'allowTargetScoreRanges'> {
  firmClient: FirmClient;
  personalRealEstateProperties: RealEstate[];
  scorecard: Scorecard;
  businessRealEstateProperties: RealEstate[];
  loans: Loan[];
  businesses: Business[];
  householdID: string;
  insurancePolicies: InsurancePolicy[];
  clickHandlers: InsuranceRateClickHandlers;
}

export const InsuranceElementDetailViewContext = createContext<IInsuranceElementDetailViewContext | null>(null);

export const InsuranceElementDetailViewContextProvider: FC<PropsWithChildren<IInsuranceElementDetailViewContext>> = ({
  children,
  ...props
}) => {
  return (
    <InsuranceElementDetailViewContext.Provider
      value={{
        ...props,
      }}
    >
      {children}
    </InsuranceElementDetailViewContext.Provider>
  );
};
